module.exports = {"upload_list":"上传列表","name":"文件","progress":"进度","size":"大小","time":"剩余时间","cancel":"取消全部","complete":"已完成","uploading":"正在上传","queue_limit_warn":"您一次最多只能添加{0}个文件","canceled":"已取消","in_the_queue":"队列中"}


//////////////////
// WEBPACK FOOTER
// ./src/language/zh-cn.json
// module id = 7q2g
// module chunks = 0 1